<div class="tw-fixed tw-inset-0 tw-z-[100] tw-bg-white tw-overflow-hidden tw-select-none">
  <div class="tw-absolute tw-inset-0" [@storySwitch]="storyIndex()">
    <ng-container [ngTemplateOutlet]="bodyTemplate()" [ngTemplateOutletContext]="context()"></ng-container>
  </div>

  <div class="tw-absolute tw-top-0 tw-left-0 tw-z-10 tw-h-full tw-w-1/4"
    (pointerdown)="onPointerDown()" (pointerup)="onPointerUp('prev')"
    (pointercancel)="onPointerCancel()" (pointerleave)="onPointerCancel()"></div>
  <div class="tw-absolute tw-top-0 tw-left-1/4 tw-z-10 tw-h-full tw-w-1/2"
    (pointerdown)="onPointerDown()" (pointerup)="onPointerUp('middle')"
    (pointercancel)="onPointerCancel()" (pointerleave)="onPointerCancel()"></div>
  <div class="tw-absolute tw-top-0 tw-right-0 tw-z-10 tw-h-full tw-w-1/4"
    (pointerdown)="onPointerDown()" (pointerup)="onPointerUp('next')"
    (pointercancel)="onPointerCancel()" (pointerleave)="onPointerCancel()"></div>

  <div class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-gap-2 tw-px-6 tw-pt-6 tw-pointer-events-none">
    @for (segment of segments(); track segment) {
      <div class="tw-h-1 tw-flex-1 tw-rounded tw-bg-gray-200 tw-overflow-hidden">
        @if (segment < slideIndex()) {
          <div class="tw-h-full tw-w-full tw-bg-gray-400"></div>
        } @else if (segment === slideIndex()) {
          @if (currentSlideIsVideo()) {
            <div class="tw-h-full tw-bg-gray-400" [style.width.%]="videoProgress() * 100"></div>
          } @else {
            <div class="story-timed-fill tw-h-full tw-bg-gray-400"
              [style.animationDuration.ms]="autoAdvanceMs()"
              [style.animationPlayState]="paused() ? 'paused' : 'running'"
              (animationend)="next()"></div>
          }
        }
      </div>
    }
  </div>

  <i class="cs-icon-close tw-absolute tw-top-10 tw-right-6 tw-z-20 tw-text-600 tw-text-gray-500 tw-cursor-pointer"
    (click)="close()"></i>

  @if (footerTemplate(); as footer) {
    <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20" [@storySwitch]="storyIndex()">
      <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="context()"></ng-container>
    </div>
  }
</div>
